import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';
import { isPositiveInteger, isTrue } from '../utils/validators';

export default class SalesforceApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('salesforce'), options);
  }

  public SupportTicketList(queries: any, limit: number = 100) {
    const query = '/salesforce/v1/tickets';
    let parameters = '?alk=1';

    if (isPositiveInteger(queries.userId)) {
      parameters += `&alk_user_id=${queries.userId}`;
    }
    if (isTrue(queries.withClosed)) {
      parameters += '&with_closed=1';
    }
    if (isPositiveInteger(limit)) {
      parameters += `&limit=${limit}`;
    }

    return this.get(query, parameters);
  }
}
